interface RealmUrlConf {
    url: string
    useHateoas: boolean;
}

interface ApiPath {
    url: string
}

export class AppConf {
    private static instance: AppConf;
    private arpApi: Record<string, RealmUrlConf>;
    private registrarApi: Record<string, RealmUrlConf>;
    private apiPath: Record<string, ApiPath>;
    public static getInstance() {
        if (!AppConf.instance) {
            AppConf.instance = new AppConf();
        }
        return AppConf.instance;
    }

    public static getArpRoot() {
        return AppConf.getInstance().arpApi;
    }

    public static getRegistrarApi() {
        return AppConf.getInstance().registrarApi;
    }

    public static getRootUrl(realm: string) {
        const urlConf: RealmUrlConf = AppConf.getInstance().arpApi[realm];
        return {url: urlConf.url, hateos: urlConf.useHateoas}
    }

    public static getRegistrarRoot(realm: string) {
        const urlConf: RealmUrlConf = AppConf.getInstance().registrarApi[realm];
        return (urlConf as any);
    }

    public static getApiPath(realm: string) {
        const apiPath: string = AppConf.getInstance().apiPath[realm].url
        return (apiPath as any)
    }

    private constructor()  {
        const {arp} = window as any;
        //console.log('ARPROOT: ', arp.arpRoot);
        this.arpApi = arp.arpApi;
        this.registrarApi = arp.registrarApi;
        this.apiPath = arp.apiPath
    }

}